<div soho-busyindicator blockUI="true" displayDelay="-1" style="height:100%;" class="busy-sm">
  <div [ngClass]="{ 'module-nav-bar': true, 'is-anonymous': anonymousUser, 'not-mingle': !mingleMode }">
    <div soho-accordion
      class="accordion panel module-nav-accordion"
      data-options="{ allowOnePane: true, rerouteOnLinkClick: false }"
      >
      <div class="module-nav-header accordion-section">
        <soho-module-nav-switcher
          #SohoModuleNavSwitcher
          class="module-nav-switcher"
          data-automation-id="lm-web-app-switcher"
          [icon]="false"
          [disabled]="anonymousUser || allowAnonymousAccess || isGuestUser || passwordReset || singleWebApp"
          [displayMode]="moduleNavDisplayMode"
          [moduleButtonText]="webAppTitle"
          [roleDropdownLabel]="webAppTitle"
          [generate]="false"
          [noSearch]="true"
          [changeIconOnSelect]="true"
          (modulebuttonclick)="onHome()"
          (listcontextmenu)="onListContextMenu($event)"
          (rolechange)="selectWebApp($event)">
        </soho-module-nav-switcher>
      </div>

      @if (showSearch && !passwordReset) {
        <lm-application-menu-search-field class="module-nav-search-container accordion-section"
          [model]="model"
          [collapsibleOnMobile]="false"
          [menuSearchMode]="menuSearchMode"
          (autoSearchMenu)="autoSearchMenu($event)"
          (fireMenuSearchEvent)="fireMenuSearchEvent($event)"
          (menuSearchCleared)="onMenuSearchCleared()">
        </lm-application-menu-search-field>
      }

      @if (showSearch && menuSearchMode) {
        <lm-application-menu-search #LMApplicationMenuSearchComponent
          class="module-nav-main accordion-section"
          [searchString]="searchString"
          [menuSpecsByWebApp]="menuSpecsByWebApp"
          [menuSearchResultsByWebApp]="menuSearchResultsByWebApp"
          [dataSearchResults]="dataSearchResults"
          [reportSearchResults]="reportSearchResults"
          [systemSearchResults]="systemSearchResults"
          (menuSearched)="onMenuSearched($event)"
          (systemMenuItemClickEvent)="onSystemMenuItemClick($event)"
          (menuLoaded)="onMenuLoaded($event)"
          (menuSearchCleared)="onMenuSearchCleared()"
        ></lm-application-menu-search>
      }
      <div class="module-nav-main accordion-section" [ngStyle]="{'display': (showSearch && menuSearchMode) ? 'none' : null }">
        @for (menuItem of menuItemSpecs; track menuItem) {
          @if (menuItem.name !== 'Home') {
            <div #AccordionHeaders
              [ngStyle]="{'visibility': (menuItem.iconName === undefined || menuItem.iconUrl === undefined && !menuItem.validSohoIcon) && moduleNavDisplayMode === 'collapsed' ? 'hidden' : 'visible' }"
              attr.id="{{menuItem.label}}-{{menuItem.menuIndex}}"
              attr.menuindex="{{menuItem.menuIndex}}"
              attr.data-automation-id="{{headerAutomationId(menuItem)}}"
              class="accordion-header"
              (contextmenu)="onMenuItemRightClicked($event, menuItem)"
              (click)="onModuleNavClick($event, menuItem)">
              @if (menuItem.validSohoIcon) {
                <svg soho-icon icon="{{menuItem.iconName}}"></svg>
              }
              @if (!menuItem.validSohoIcon && menuItem.iconUrl) {
                <img class="icon" src="{{menuItem.iconUrl}}"/>
              }
              <a href="#"
                attr.navigationmenuurl="{{menuItem?.navigationMenuUrl || menuItem?.link}}"
                attr.id="{{menuItem.id}}"
                attr.data-automation-id="{{dataAutomationId(menuItem)}}"
                ><span>{{menuItem?.label}}</span></a>
              </div>
              @if (menuItem.menu) {
                <lm-application-menu-submenu
                  #ApplicationMenuSubmenus
                  [ngClass]="{'accordion-pane': menuItem.menu, 'has-icons': menuItem.iconName !== undefined}"
                  [menuItemSpecs]="menuItem.menu"
                  (menuLoaded)="onMenuLoaded($event)">
                </lm-application-menu-submenu>
              }
            }
          }
        </div>
        <!-- pinned items -->
        @if (!searchMode) {
          <div class="module-nav-footer accordion-section">
            @if (inbasketEnabled && inbasketButton && inbasketButton.url) {
              <div
                class="accordion-header"
                attr.data-automation-id="{{inbasketButton.automationId}}"
                (click)="openLink(inbasketButton.url)"
                >
                <svg soho-icon [icon]="inbasketButton.icon" attr.title="{{inbasketButton.label}}"></svg>
                <a href="#">
                  <span>{{inbasketButton.label}}</span>
                </a>
              </div>
            }
            @if (notificationEnabled && notificationsButton && notificationsButton.url) {
              <div
                style="position: relative;"
                class="accordion-header"
                (click)="openLink(notificationsButton.url)"
                attr.data-automation-id="{{notificationsButton.automationId}}"S
                >
                <span [ngClass]="{'red-dot' : displayRedDot }"
                        [ngStyle]="{
                            'left': moduleNavDisplayMode === 'collapsed' ? '21px' : '19px',
                            'top': moduleNavDisplayMode === 'collapsed' ? '13px' : '13px'
                        }"
                ></span>
                <svg soho-icon [icon]="notificationsButton.icon" attr.title="{{notificationsButton.label}}"></svg>
                <a href="#">
                  <span>{{notificationsButton.label}}</span>
                </a>
              </div>
            }
            @if (reportsButton && reportsButton.url) {
              <div
                class="accordion-header"
                attr.data-automation-id="{{reportsButton.automationId}}"
                (click)="openLink(reportsButton.url)"
                >
                <svg soho-icon [icon]="reportsButton.icon" attr.title="{{reportsButton.label}}"></svg>
                <a href="#">
                  <span>{{reportsButton.label}}</span>
                </a>
              </div>
            }
            @if (printFilesButton && printFilesButton.url) {
              <div
                class="accordion-header"
                attr.data-automation-id="{{printFilesButton.automationId}}"
                (click)="openLink(printFilesButton.url)"
                >
                <svg soho-icon [icon]="printFilesButton.icon" attr.title="{{printFilesButton.label}}"></svg>
                <a href="#">
                  <span>{{printFilesButton.label}}</span>
                </a>
              </div>
            }
            @if (signOutLink && (!mingleMode && !inNativeMobileApp)) {
              <div class="accordion-header"
                data-automation-id="lm-appmenu-logout-button"
                (click)="openSecurityLink(signOutLink)"
                >
                <svg soho-icon [icon]="'logout'" attr.title="{{isGuestUser ? 'Exit' : 'SignOut' | translate }}"></svg>
                <a id="Logout_button">
                  <span>{{isGuestUser ? 'Exit' : 'SignOut' | translate }}</span>
                </a>
              </div>
            }
            @if (anonymousUser) {
              @if (clientLogin) {
                <div
                  class="accordion-header"
                  data-automation-id="lm-appmenu-login-button"
                  (click)="openLoginWindow()"
                  >
                  <svg soho-icon [icon]="'login'" attr.title="{{ 'SignIn' | translate }}"></svg>
                  <a href="javascript:void(0);">
                    <span>{{ 'SignIn' | translate }}</span>
                  </a>
                </div>
              }
              @if (!clientLogin) {
                <div
                  class="accordion-header"
                  data-automation-id="lm-appmenu-login-button"
                  (click)="openSecurityLink(signInLink)"
                  >
                  <svg soho-icon [icon]="'login'" attr.title="{{ 'SignIn' | translate }}"></svg>
                  <a href="javascript:void(0);">
                    <span>{{ 'SignIn' | translate }}</span>
                  </a>
                </div>
              }
              @if (hasRegisterLink) {
                <div
                  class="accordion-header"
                  data-automation-id="lm-appmenu-register-button"
                  (click)="openLink(registerLink)"
                  >
                  <svg soho-icon [icon]="'locked'" attr.title="{{ 'Register' | translate }}"></svg>
                  <a href="javascript:void(0);">
                    <span>{{ 'Register' | translate }}</span>
                  </a>
                </div>
              }
            }
          </div>
        }

        @if (!anonymousUser && !isGuestUser && !passwordReset) {
          <div [ngStyle]="{'display': !searchMode ? 'block' : 'none'}" class="module-nav-settings accordion-section">
            <soho-module-nav-settings>
              <div soho-menu-button
                id="module-nav-settings-btn"
                class="module-nav-settings-btn accordion-header"
                title="{{'More' | translate}}"
                data-automation-id="lm-appmenu-settings-menu-button"
                [icon]="'settings'"
                [hideMenuArrow]="true"
                [showArrow]="false"
                [autoFocus]="true"
                [returnFocus]="true"
                [ripple]="false"
                [menu]="'module-nav-settings-menu'">
                <a href="javascript:void(0);"><span>{{'More' | translate}}</span></a>
              </div>
              <ul soho-popupmenu id="module-nav-settings-menu" class="module-nav-settings-menu" data-automation-id="lm-appmenu-settings-menu">
                @for (button of applicationMenuButtons; track button) {
                  @if (button.url) {
                    <li soho-popupmenu-item id="{{button.id}}" (click)="openLink(button.url)">
                      <a soho-popupmenu-label href="" attr.data-automation-id="{{button.automationId}}">
                        <svg soho-icon [icon]="button.icon"></svg>
                        <span>{{ button.label }}</span>
                      </a>
                    </li>
                  }
                }
                @if (allowSetAsOfDate
                  || showProxy
                  || enableUserContextMenu
                  || createReportUrl && !reportsButton) {
                  <li
                    soho-popupmenu-separator class="separator"
                  ></li>
                }
                @if (allowSetAsOfDate) {
                  <li soho-popupmenu-item (click)="openSetAsOfDateDialog()">
                    <a hsoho-popupmenu-label href="" data-automation-id="lm-appmenu-set-as-of-date-button">
                      <svg soho-icon [icon]="'calendar'"></svg>
                      <span>{{ 'AsOfDateLabel' | translate }}</span>
                    </a>
                  </li>
                }
                @if (showProxy) {
                  <li soho-popupmenu-item (click)="openProxyPage()">
                    <a soho-popupmenu-label href="" data-automation-id="lm-appmenu-proxy-button">
                      <span>{{ 'Proxy' | translate }}</span>
                    </a>
                  </li>
                }
                @if (enableUserContextMenu) {
                  <li soho-popupmenu-item (click)="openSetUserContextDialog()">
                    <a soho-popupmenu-label href="" data-automation-id="lm-appmenu-user-context-button">
                      <span>{{ 'ActorContextMenuLabel' | translate }}</span>
                    </a>
                  </li>
                }
                @if (!showReportCatalog) {
                  <li soho-popupmenu-item (click)="runCreateReport()">
                    <a soho-popupmenu-label href="" data-automation-id="lm-appmenu-create-report-button">
                      <span>{{ 'CreateReport' | translate }}</span>
                    </a>
                  </li>
                }
                @if (hasChangePasswordLink || appHelpLink || aboutLink) {
                  <li soho-popupmenu-separator class="separator"></li>
                }
                @if (hasChangePasswordLink) {
                  <li soho-popupmenu-item  (click)="openChangePasswordWindow()">
                    <a soho-popupmenu-label
                      id="ChangePassword_button"
                      data-automation-id="lm-appmenu-change-password-button"
                    >{{ 'ChangePassword' | translate }}</a>
                  </li>
                }
                @if (!hasChangePasswordLink) {
                  <li soho-popupmenu-item (click)="openUserSettingsDialog()">
                    <a soho-popupmenu-label id="Settings_button" href="" data-automation-id="lm-appmenu-settings-button">
                      <svg soho-icon [icon]="'advance-settings'"></svg>
                      <span>{{ 'Settings' | translate }}</span>
                    </a>
                  </li>
                }
                @if (appHelpLink && !hasChangePasswordLink) {
                  <li soho-popupmenu-item (click)="openHelpLink()">
                    <a soho-popupmenu-label id="Help_button" href="" data-automation-id="lm-appmenu-help-button">
                      <svg soho-icon [icon]="'help'"></svg>
                      <span>{{ 'Help' | translate }}</span>
                    </a>
                  </li>
                }
                @if (aboutLink && !hasChangePasswordLink) {
                  <li soho-popupmenu-item (click)="openLink(aboutButton.url)">
                    <a soho-popupmenu-label id="About_button" href="" data-automation-id="lm-appmenu-about-button">
                      <svg soho-icon [icon]="'info-linear'"></svg>
                      <span>{{ 'About' | translate }}</span>
                    </a>
                  </li>
                }
              </ul>
            </soho-module-nav-settings>
          </div>
        }

        @if (mingleMode && proxyMode) {
          <div class="application-menu-actor-info-container is-proxy">
            <h2 data-automation-id="lm-appmenu-actor-name" class="actor-name">{{actorName}}</h2>
          </div>
        } @else {
          @if (!mingleMode && !inNativeMobileApp) {
            <div class="module-nav-guest accordion-section">
              <a href="javascript:void(0);" class="module-nav-guest-link">
                @if (!anonymousUser) {
                  @if (noActorUrl()) {
                    <div  class="avatar round {{actorInitialsColorClass}}">{{actorInitials}}</div>
                  }
                  @if (!noActorUrl()) {
                    <img class="avatar round" [src]="actorUrl" alt=""/>
                  }
                }
                <div class="module-nav-guest-text">
                  <span class="module-nav-guest-title">{{ 'Welcome' | translate }},</span>
                  @if (anonymousUser) {
                    <span class="module-nav-guest-subtext" data-automation-id="lm-appmenu-actor-name">{{'Guest' | translate}}</span>
                  }
                  @if (!anonymousUser) {
                    <span class="module-nav-guest-subtext" data-automation-id="lm-appmenu-actor-name">{{actorName}}</span>
                  }
                </div>
              </a>
            </div>
          }
        }
      </div>
    </div>
  </div>

  <div #menuFormDialog>
    <!-- dialog placeholder used to display action form from menu -->
  </div>